import { useEffect, useRef, useState } from 'react';

export const useScrollAnimation = (threshold = 0.05, options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();
  const timeoutRef = useRef();

  useEffect(() => {
    const currentRef = ref.current;
    
    // Very fast fallback timer for immediate backup animation
    timeoutRef.current = setTimeout(() => {
      setIsVisible(true);
    }, 300); // Show content after 300ms regardless (very fast)
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Clear the fallback timer since intersection worked
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          // Unobserve after animation triggers to prevent re-triggering
          observer.unobserve(entry.target);
        }
      },
      {
        threshold,
        // Extremely aggressive trigger - starts animation when element is far from viewport
        rootMargin: options.rootMargin || '300px 0px -50px 0px' 
      }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [threshold, options.rootMargin]);

  return [ref, isVisible];
};

export default useScrollAnimation;